import { LANGUAGE_CODE } from '@healthhub/react-ui';
import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  HEALTHIERSG_ABOUT_PATH,
  HEALTHIERSG_ENROLLMENT_APPOINTMENTS_PATH,
  HEALTHIERSG_ENROLLMENT_CARERECIPIENT_PATH,
  HEALTHIERSG_ENROLLMENT_CHANGE_PATH,
  HEALTHIERSG_ENROLLMENT_COMPLETE_PATH,
  HEALTHIERSG_ENROLLMENT_CONFIRM_PATH,
  HEALTHIERSG_ENROLLMENT_EXISTING_APPOINTMENT_PATH,
  HEALTHIERSG_ENROLLMENT_FILTER_PATH,
  HEALTHIERSG_ENROLLMENT_INTRO_PATH,
  HEALTHIERSG_ENROLLMENT_INTROFIRSTSTEP_PATH,
  HEALTHIERSG_ENROLLMENT_INTROSPLASH_PATH,
  HEALTHIERSG_ENROLLMENT_MORE_OPTIONS_PATH,
  HEALTHIERSG_ENROLLMENT_PATH,
  HEALTHIERSG_ENROLLMENT_TERMS_PATH,
  HEALTHIERSG_HEALTHPLAN_ACTIVITY_DETAILS,
  HEALTHIERSG_HEALTHPLAN_ACTIVITY_DETAILS_LIFESTYLEACTIONS,
  HEALTHIERSG_HEALTHPLAN_ERROR_PAGE_PATH,
  HEALTHIERSG_HEALTHPLAN_EXERCISE_DETAILS,
  HEALTHIERSG_HEALTHPLAN_EXERCISE_DETAILS_LIFESTYLEACTIONS,
  HEALTHIERSG_HEALTHPLAN_EXERCISE_PLAN,
  HEALTHIERSG_HEALTHPLAN_EXERCISE_PLAN_FEEDBACK,
  HEALTHIERSG_HEALTHPLAN_GET_VACCINATED_PATH,
  HEALTHIERSG_HEALTHPLAN_PATH,
  HEALTHIERSG_HEALTHPLAN_SIGNPOSTING_PATH,
  HEALTHIERSG_HEALTHPLAN_SUMMARY_PATH,
  HEALTHIERSG_HEALTHPLAN_VACCINATION_DETAIL_PATH,
  HEALTHIERSG_HEALTHPLAN_VIEW_DISMISSED_ACTIONS_PATH,
  HEALTHIERSG_IMMUNISATIONS_RECORDS_PATH,
  HEALTHIERSG_LIFESTYLE_ACTION_LEARN_HOW_PATH,
  HEALTHIERSG_LIFESTYLE_ACTIONS_RECOMMENDED_ARTICLES_PATH,
  HEALTHIERSG_LIFESTYLEACTIONS_PATH,
  HEALTHIERSG_NO_ACCESS_PATH,
  HEALTHIERSG_PREVIOUS_HEALTHPLAN_DETAIL_PATH,
  HEALTHIERSG_PREVIOUS_HEALTHPLAN_PATH,
  HEALTHIERSG_QUESTIONNAIRE_COMPLETED_PATH,
  HEALTHIERSG_QUESTIONNAIRE_ONBOARDING_ANS_PATH,
  HEALTHIERSG_QUESTIONNAIRE_ONBOARDING_PATH,
  HEALTHIERSG_QUESTIONNAIRE_PATH,
  HEALTHIERSG_QUESTIONNAIRE_SCF_PATH,
  HEALTHIERSG_QUESTIONNAIRE_SMOKING_DETAILS_PATH,
  HEALTHIERSG_QUESTIONNAIRE_SMOKING_PATH,
  HEALTHIERSG_RECOMMENDATION_SIGNPOSTING_PATH,
  HEALTHIERSG_RECOMMENDED_PROGRAMMES_AND_ACTIVITIES_PATH,
  HEALTHIERSG_RECORDS_COMPLETED_IMMUNISATION_PATH,
  HEALTHIERSG_RECORDS_HEALTH_SCREENING_PATH,
  HEALTHIERSG_RECORDS_MANAGE_CONDITION_PATH,
  HEALTHIERSG_RECORDS_MISSED_IMMUNISATION_PATH,
  HEALTHIERSG_RECORDS_MORE_ABOUT_IMMUNISATION_PATH,
  HEALTHIERSG_RECORDS_NATIONALLY_RECOMMENDED_IMMUNISATION_PATH,
  HEALTHIERSG_RECORDS_SCREENING_DETAILED_RESULTS_PATH,
  HEALTHIERSG_RECORDS_SCREENING_DETAILS_PATH,
  HEALTHIERSG_RECORDS_SCREENING_HISTORY_PATH,
  HEALTHIERSG_RECORDS_SCREENING_LATEST_DETAILS_PATH,
  HEALTHIERSG_RECORDS_SCREENING_LISTING_PATH,
  HEALTHIERSG_RECORDS_SCREENING_PATH,
  HEALTHIERSG_RECORDS_SCREENING_RESULTS_INDICATOR_PATH,
  HEALTHIERSG_RECORDS_SCREENING_RESULTS_PATH,
  HEALTHIERSG_RECORDS_SCREENING_UNDERSTAND_READINGS_PATH,
  HEALTHIERSG_RECORDS_UPCOMING_IMMUNISATION_PATH,
  HEALTHIERSG_RESOURCES_LIVE_HEALTHY_ARTICLES_PATH,
  HEALTHIERSG_RESULTSANDRECORDS_EDIT_PATH,
  HEALTHIERSG_RESULTSANDRECORDS_PATH,
  HEALTHIERSG_SCREENING_DETAILED_RESULTS_PATH,
  HEALTHIERSG_SCREENING_JOURNEY_APPOINTMENT_MADE_PATH,
  HEALTHIERSG_SCREENING_JOURNEY_AVAILABLE_ON_PATH,
  HEALTHIERSG_SCREENING_JOURNEY_GO_FOR_SCREENING_PATH,
  HEALTHIERSG_SCREENING_JOURNEY_NOT_AVAILABLE_PATH,
  HEALTHIERSG_SCREENING_JOURNEY_TO_BOOK_PATH,
  HEALTHIERSG_SCREENING_QUESTION_PATH,
  HEALTHIERSG_SCREENING_RESULTS_INDICATOR_PATH,
  HEALTHIERSG_SCREENING_RESULTS_PATH,
  HEALTHIERSG_SCREENING_RESULTS_PENDING_PATH,
  HEALTHIERSG_SCREENING_UNDERSTAND_READINGS_PATH,
  HEALTHIERSG_SMOKING_CESSATION_GOAL_SUPPORT_ARTICLES_PATH,
  HEALTHIERSG_SMOKING_CESSATION_HISTORY_PATH,
  HEALTHIERSG_SMOKING_CESSATION_QUIT_GOAL_SUPPORT_PATH,
  HEALTHIERSG_VACCINATION_ARTICLES_PATH,
  HEALTHIERSG_WHATS_NEW_PATH,
  HEALTHIERSG_YOUR_IMMUNISATION_RECORDS_PATH,
  LIFESTYLEACTIONS_HEALTHPLAN_EXERCISE_PLAN,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

import { HSG_APPOINTMENTS_ROUTES } from './Appointments/routes';
import { HSG_SCREENING_STATUS } from './constants';

const SelectUserPage = lazy(() => import('./Enrollment/pages/SelectUserPage'));
const WelcomeToHSGPage = lazy(() => import('./Enrollment/pages/WelcomeToHSGPage'));
const EnrollmentTermsPage = lazy(() => import('./Enrollment/pages/EnrollmentTermsPage'));
const EnrollmentSignpostingPage = lazy(() => import('./Enrollment/pages/EnrollmentSignpostingPage'));
const EnrollmentSplashScreenPage = lazy(() => import('./Enrollment/pages/EnrollmentSplashScreenPage'));
const ClinicSelectionPage = lazy(() => import('./Enrollment/pages/ClinicSelectionPage'));
const EnrollmentFilterPage = lazy(() => import('./Enrollment/pages/EnrollmentFilterPage'));
const ConfirmEnrollmentPage = lazy(() => import('./Enrollment/pages/ConfirmEnrollmentPage'));
const EnrolmentCompletedPage = lazy(() => import('./Enrollment/pages/EnrolmentCompletedPage'));
const EnrollmentMoreOptionsPage = lazy(() => import('./Enrollment/pages/EnrollmentMoreOptionsPage'));
const FinUserNotificationPage = lazy(() => import('./Enrollment/pages/FinUserNotificationPage'));
const WhatsNewPage = lazy(() => import('./HealthPlan/pages/WhatsNewPage'));
const OnboardingQuestionnairePage = lazy(() => import('./Questionnaire/pages/OnboardingQuestionnairePage'));
const ViewCompletedOnboardingPage = lazy(() => import('./Questionnaire/pages/ViewCompletedOnboardingPage'));
const SmokingQuestionairePage = lazy(() => import('./Questionnaire/pages/SmokingQuestionairePage'));
const PastSmokingSubmissionPage = lazy(() => import('./Questionnaire/pages/PastSmokingSubmissionPage'));
const ViewCompletedSmokingPage = lazy(() => import('./Questionnaire/pages/ViewCompletedSmokingPage'));
const HealthPlanPage = lazy(() => import('./HealthPlan/pages/HealthPlanPage'));
const HealthRecordsPage = lazy(() => import('./HealthPlan/pages/HealthRecordsPage'));
const AboutPage = lazy(() => import('./HealthPlan/pages/AboutPage'));
const HealthPlanSummaryPage = lazy(() => import('./HealthPlan/pages/HealthPlanSummaryPage'));
const CompletedQuestionnairePage = lazy(() => import('./Questionnaire/pages/CompletedQuestionnairePage'));
const QuestionnairePage = lazy(() => import('./Questionnaire/pages/QuestionnairePage'));
const LifestyleActionsPage = lazy(() => import('./LifestyleActions/pages/LifeStyleActionsPage'));
const LiveHealthyArticlesPage = lazy(() => import('./HealthPlan/pages/LiveHealthyArticlesPage'));
const HealthPlanSignPostingPage = lazy(() => import('./HealthPlan/pages/HealthPlanSignPostingPage'));
const HSGErrorPage = lazy(() => import('./HealthPlan/pages/HSGErrorPage'));
const RecommendationSignPostingPage = lazy(() => import('./Recommendation/pages/RecommendationSignPostingPage'));
const ScreeningPage = lazy(() => import('./Records/pages/ScreeningPage'));
const ScreeningJourneyPage = lazy(() => import('./Records/pages/ScreeningJourneyPage/ScreeningJourneyPage'));
const GetVaccinatedPage = lazy(() => import('./HealthPlan/pages/GetVaccinatedPage'));
const RecommendedProgrammesAndActivitiesPage = lazy(
  () => import('./Recommendation/pages/RecommendedProgrammesAndActivitiesPage')
);
const VaccinationDetailPage = lazy(() => import('./HealthPlan/pages/VaccinationDetailPage'));
const ScreeningListingPage = lazy(() => import('./Records/pages/ScreeningListingPage'));
const ScreeningHistoryPage = lazy(() => import('./Records/pages/ScreeningHistoryPage'));
const DismissedActionsPage = lazy(() => import('./HealthPlan/pages/DismissedActionsPage'));
const SmokingCessationHistoryPage = lazy(() => import('./HealthPlan/pages/SmokingCessationPage/SmokingHistoryPage'));
const SmokingCessationQuitGoalSupportPage = lazy(
  () => import('./HealthPlan/pages/SmokingCessationPage/SmokingCessationQuitGoalSupportPage')
);
const ResultsandRecordsEdit = lazy(() => import('./HealthPlan/pages/ResultsAndRecords'));
const ScreeningDetailPage = lazy(() => import('./Records/pages/ScreeningDetailPage'));
const PreviousHealthPlan = lazy(() => import('./HealthPlan/pages/PreviousHealthPlanPage'));
const PreviousHealthPlanDetail = lazy(() => import('./HealthPlan/pages/PreviousHealthPlanDetailPage'));
const LifestyleActionsLearnHowPage = lazy(() => import('./LifestyleActions/pages/LifestyleActionsLearnHowPage'));
const ExistingAppointment = lazy(() => import('./Enrollment/pages/ExistingAppointment'));
const ImmunisationPage = lazy(() => import('./Immunisation/pages/ImmunisationPage'));
const YourImmunisationRecordsPage = lazy(() => import('./Immunisation/pages/YourImmunisationRecordsPage'));
const CompletedImmunisationPage = lazy(() => import('./Immunisation/pages/CompletedImmunisationPage'));
const NationallyRecommendedPage = lazy(() => import('./Immunisation/pages/NationallyRecommendedPage'));
const MoreAboutImmunisationPage = lazy(() => import('./Immunisation/pages/MoreAboutImmunisationPage'));
const MissedImmunisationsPage = lazy(() => import('./Immunisation/pages/MissedImmunisationsPage'));
const UpcomingImmunisationsPage = lazy(() => import('./Immunisation/pages/UpcomingImmunisationsPage'));
const ManageConditionPage = lazy(() => import('./HealthPlan/pages/ManageConditionPage'));
const LifeStyleActionsArticlesPage = lazy(() => import('./HealthPlan/pages/LifeStyleActionsArticlesPage'));
const SmokingCessationGoalSupportArticlesPage = lazy(
  () => import('./HealthPlan/pages/SmokingCessationPage/SmokingCessationGoalSupportArticlesPage')
);
const EnrollmentAppointmentsPage = lazy(() => import('./Enrollment/pages/EnrollmentAppointmentsPage'));
const ScreeningQuestionPage = lazy(() => import('./Records/pages/ScreeningQuestionPage'));
const ScreeningResultsPage = lazy(() => import('./Records/pages/ScreeningResultsPage/ScreeningResultsPage'));
const HealthScreeningDetailedResultsPage = lazy(
  () => import('./Records/pages/HealthScreeningDetailedResultsPage/HealthScreeningDetailedResultsPage')
);
const LatestScreeningDetailPage = lazy(() => import('./Records/pages/LatestScreeningDetailPage'));
const ScreeningResultsIndicatorsPage = lazy(
  () => import('./Records/pages/ScreeningResultsIndicatorPage/ScreeningResultsIndicatorPage')
);

const ScreeningReadingsPage = lazy(() => import('./Records/pages/ScreeningReadingsPage'));
const VaccinationArticlesPage = lazy(
  () => import('./HealthPlan/pages/VaccinationArticlesPage/VaccinationArticlesPage')
);

const ExercisePlanPage = lazy(() => import('./HealthPlan/pages/ExercisePlanPage'));
const ExerciseDetailsPage = lazy(() => import('./HealthPlan/pages/ExerciseDetailsPage'));
const FeedbackPage = lazy(() => import('./HealthPlan/pages/FeedbackPage'));
const ActivityDetailsPage = lazy(() => import('./HealthPlan/pages/ActivityDetailsPage'));

export const HSG_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SelectUserPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_CARERECIPIENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'careRecipientListing.mobileDisplayTitle',
    translationFile: 'hsg',
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <WelcomeToHSGPage />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_INTRO_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'intro.introTitle',
    translationFile: 'hsg',
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <EnrollmentTermsPage />,
    displayTitle: () => 'termsOfUse.termsTitle',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_TERMS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'termsOfUse.termsTitle',
    translationFile: 'hsg',
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <EnrollmentSignpostingPage />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_INTROFIRSTSTEP_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'intro.introTitle',
    translationFile: 'hsg',
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <EnrollmentSplashScreenPage />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_INTROSPLASH_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'intro.introTitle',
    translationFile: 'hsg',
  },
  {
    path: HEALTHIERSG_HEALTHPLAN_EXERCISE_PLAN,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <ExercisePlanPage />,
    displayTitle: () => '',
    titleTransKey: 'breadcrumbs.exercisePlan',
    translationFile: 'hsg',
    pageType: PageType.PRIVATE,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    backUrl: HEALTHIERSG_HEALTHPLAN_PATH,
  },
  {
    path: LIFESTYLEACTIONS_HEALTHPLAN_EXERCISE_PLAN,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <ExercisePlanPage lifeStyleActions />,
    displayTitle: () => '',
    titleTransKey: 'breadcrumbs.exercisePlan',
    translationFile: 'hsg',
    pageType: PageType.PRIVATE,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    backUrl: HEALTHIERSG_LIFESTYLEACTIONS_PATH,
  },
  {
    path: HEALTHIERSG_HEALTHPLAN_EXERCISE_DETAILS,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <ExerciseDetailsPage />,
    displayTitle: () => '',
    titleTransKey: 'breadcrumbs.exerciseDetails',
    translationFile: 'hsg',
    pageType: PageType.PRIVATE,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
  },
  {
    path: HEALTHIERSG_HEALTHPLAN_EXERCISE_DETAILS_LIFESTYLEACTIONS,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <ExerciseDetailsPage lifeStyleActions />,
    displayTitle: () => '',
    titleTransKey: 'breadcrumbs.exerciseDetails',
    translationFile: 'hsg',
    pageType: PageType.PRIVATE,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
  },
  {
    path: HEALTHIERSG_HEALTHPLAN_EXERCISE_PLAN_FEEDBACK,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <FeedbackPage />,
    displayTitle: () => '',
    titleTransKey: 'breadcrumbs.exercisePlanFeedback',
    translationFile: 'hsg',
    pageType: PageType.PRIVATE,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
  },
  {
    path: HEALTHIERSG_HEALTHPLAN_ACTIVITY_DETAILS,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <ActivityDetailsPage />,
    displayTitle: () => '',
    titleTransKey: 'breadcrumbs.activityDetails',
    translationFile: 'hsg',
    pageType: PageType.PRIVATE,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
  },
  {
    path: HEALTHIERSG_HEALTHPLAN_ACTIVITY_DETAILS_LIFESTYLEACTIONS,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <ActivityDetailsPage lifeStyleActions />,
    displayTitle: () => '',
    titleTransKey: 'breadcrumbs.activityDetails',
    translationFile: 'hsg',
    pageType: PageType.PRIVATE,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    backUrl: HEALTHIERSG_HEALTHPLAN_PATH,
    component: () => <GetVaccinatedPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_HEALTHPLAN_GET_VACCINATED_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.getVaccinated',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <VaccinationDetailPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_HEALTHPLAN_VACCINATION_DETAIL_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.vaccinationDetail',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <ClinicSelectionPage />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'clinicSelectionEnrolment',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <EnrollmentFilterPage />,
    displayTitle: () => 'filterDetails.title',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_FILTER_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'filterDetails.title',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <ConfirmEnrollmentPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_CONFIRM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'clinicSelectionEnrolment',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <EnrolmentCompletedPage />,
    displayTitle: () => 'Enrolment Completed',
    isLandingPage: true,
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_COMPLETE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    backUrl: HEALTHIERSG_HEALTHPLAN_PATH,
    component: () => <EnrollmentMoreOptionsPage />,
    displayTitle: () => 'moreOptions.header',
    isNavHeaderHide: false,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_MORE_OPTIONS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'moreOptions.header',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <ClinicSelectionPage isChangePcp />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_CHANGE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'clinicSelectionEnrolment',
    translationFile: 'hsg',
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <FinUserNotificationPage />,
    displayTitle: () => 'finUserError.header',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_NO_ACCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'finUserError.header',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <OnboardingQuestionnairePage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_QUESTIONNAIRE_ONBOARDING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.onboardingQuestion',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ViewCompletedOnboardingPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_QUESTIONNAIRE_ONBOARDING_ANS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'questionnaireLibrary.viewCompletedTitle',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <SmokingQuestionairePage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_QUESTIONNAIRE_SMOKING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'questionnaireLibrary.smokingCessationTitleMobile',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <PastSmokingSubmissionPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_QUESTIONNAIRE_SCF_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'questionnaireLibrary.smokingCessationTitleMobile',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ViewCompletedSmokingPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_QUESTIONNAIRE_SMOKING_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'questionnaireLibrary.viewCompletedTitle',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <CompletedQuestionnairePage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_QUESTIONNAIRE_COMPLETED_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'questionnaireLibrary.viewCompletedTitle',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    backUrl: HEALTHIERSG_HEALTHPLAN_PATH,
    component: () => <QuestionnairePage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_QUESTIONNAIRE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.questionnaireLibrary',
    translationFile: 'hsg',
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthPlanPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_HEALTHPLAN_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <HealthPlanSignPostingPage />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_HEALTHPLAN_SIGNPOSTING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthPlan',
    translationFile: 'hsg',
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HSGErrorPage />,
    displayTitle: () => '',
    isHideBackNavButton: true,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_HEALTHPLAN_ERROR_PAGE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthPlan',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <WhatsNewPage />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_WHATS_NEW_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <RecommendationSignPostingPage />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECOMMENDATION_SIGNPOSTING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <RecommendedProgrammesAndActivitiesPage />,
    displayTitle: () => '',
    isLandingPage: false,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECOMMENDED_PROGRAMMES_AND_ACTIVITIES_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.recommendedActivities',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthRecordsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RESULTSANDRECORDS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
    backUrl: HEALTHIERSG_HEALTHPLAN_PATH,
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <AboutPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ABOUT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <WhatsNewPage />,
    displayTitle: () => '',
    isNavHeaderHide: true,
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_WHATS_NEW_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    backUrl: HEALTHIERSG_HEALTHPLAN_PATH,
    component: () => <HealthPlanSummaryPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_HEALTHPLAN_SUMMARY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthPlanSummary',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LifestyleActionsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_LIFESTYLEACTIONS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.lifeStyleActions',
    translationFile: 'hsg',
    backUrl: HEALTHIERSG_HEALTHPLAN_PATH,
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LiveHealthyArticlesPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RESOURCES_LIVE_HEALTHY_ARTICLES_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.liveHealthy',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_SCREENING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSGScreening',
    translationFile: 'hsg',
    backUrl: HEALTHIERSG_HEALTHPLAN_PATH,
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningPage isFromHealthScreenings />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_HEALTH_SCREENING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSGScreening',
    translationFile: 'hsg',
    actionUrl: ACTION_BACK_PATH,
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningListingPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_SCREENING_LISTING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningHistoryPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_SCREENING_HISTORY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <DismissedActionsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_HEALTHPLAN_VIEW_DISMISSED_ACTIONS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.viewDismissedActions',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningDetailPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_SCREENING_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <SmokingCessationHistoryPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_SMOKING_CESSATION_HISTORY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.smokingHistory',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <SmokingCessationQuitGoalSupportPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_SMOKING_CESSATION_QUIT_GOAL_SUPPORT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.quitGoalSupport',
    translationFile: 'hsg',
  },

  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ResultsandRecordsEdit />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RESULTSANDRECORDS_EDIT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.editBasicHealthInformation',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <PreviousHealthPlan />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_PREVIOUS_HEALTHPLAN_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.viewPreviousHealthPlan',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <PreviousHealthPlanDetail />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_PREVIOUS_HEALTHPLAN_DETAIL_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LifestyleActionsLearnHowPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_LIFESTYLE_ACTION_LEARN_HOW_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.lifeStyleActions',
    translationFile: 'hsg',
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <ExistingAppointment />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_ENROLLMENT_EXISTING_APPOINTMENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.existingAppointment',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <YourImmunisationRecordsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_YOUR_IMMUNISATION_RECORDS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.yourImmunisationRecords',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <CompletedImmunisationPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_COMPLETED_IMMUNISATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <NationallyRecommendedPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_NATIONALLY_RECOMMENDED_IMMUNISATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <MoreAboutImmunisationPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_MORE_ABOUT_IMMUNISATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },

  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <UpcomingImmunisationsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_UPCOMING_IMMUNISATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <MissedImmunisationsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_MISSED_IMMUNISATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ManageConditionPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_MANAGE_CONDITION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.manageCondition',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LifeStyleActionsArticlesPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_LIFESTYLE_ACTIONS_RECOMMENDED_ARTICLES_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.lifeStyleActions',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <SmokingCessationGoalSupportArticlesPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_SMOKING_CESSATION_GOAL_SUPPORT_ARTICLES_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.quitGoalSupport',
    translationFile: 'hsg',
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ImmunisationPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_IMMUNISATIONS_RECORDS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.immunisationRecords',
    translationFile: 'hsg',
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <EnrollmentAppointmentsPage />,
    displayTitle: () => '',
    path: HEALTHIERSG_ENROLLMENT_APPOINTMENTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    path: HEALTHIERSG_SCREENING_JOURNEY_TO_BOOK_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <ScreeningJourneyPage status={HSG_SCREENING_STATUS.READY_BOOK} />,
    displayTitle: () => '',
    titleTransKey: 'breadcrumbs.healthierSGScreening',
    translationFile: 'hsg',
    pageType: PageType.PRIVATE,
    backUrl: HEALTHIERSG_RECORDS_SCREENING_PATH,
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    path: HEALTHIERSG_SCREENING_JOURNEY_GO_FOR_SCREENING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <ScreeningJourneyPage status={HSG_SCREENING_STATUS.GO_SCREENING} />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    titleTransKey: 'breadcrumbs.healthierSGScreening',
    translationFile: 'hsg',
    backUrl: HEALTHIERSG_RECORDS_SCREENING_PATH,
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    path: HEALTHIERSG_SCREENING_JOURNEY_NOT_AVAILABLE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <ScreeningJourneyPage status={HSG_SCREENING_STATUS.NOT_AVAILABLE} />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    titleTransKey: 'breadcrumbs.healthierSGScreening',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    path: HEALTHIERSG_SCREENING_JOURNEY_AVAILABLE_ON_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <ScreeningJourneyPage status={HSG_SCREENING_STATUS.AVAILABLE_ON} />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    titleTransKey: 'breadcrumbs.healthierSGScreening',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    path: HEALTHIERSG_SCREENING_JOURNEY_APPOINTMENT_MADE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    component: () => <ScreeningJourneyPage status={HSG_SCREENING_STATUS.APPOINTMENT_MADE} />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    titleTransKey: 'breadcrumbs.healthierSGScreening',
    translationFile: 'hsg',
    backUrl: HEALTHIERSG_RECORDS_SCREENING_PATH,
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <ScreeningQuestionPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_SCREENING_QUESTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSGScreening',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningResultsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_SCREENING_RESULTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSGScreening',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <ScreeningJourneyPage status={HSG_SCREENING_STATUS.PENDING_RESULTS} />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_SCREENING_RESULTS_PENDING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSGScreening',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningResultsPage isFromHealthRecords />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_SCREENING_RESULTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSGScreening',
    translationFile: 'hsg',
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthScreeningDetailedResultsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_SCREENING_DETAILED_RESULTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.screeningResults',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <HealthScreeningDetailedResultsPage isFromHealthRecords />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_SCREENING_DETAILED_RESULTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.screeningResults',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <LatestScreeningDetailPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_SCREENING_LATEST_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.healthierSG',
    translationFile: 'hsg',
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningResultsIndicatorsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_SCREENING_RESULTS_INDICATOR_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.screeningResultIndicator',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningResultsIndicatorsPage isFromHealthRecords />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_SCREENING_RESULTS_INDICATOR_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.screeningResultIndicator',
    translationFile: 'hsg',
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningReadingsPage isFromHealthRecords />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_RECORDS_SCREENING_UNDERSTAND_READINGS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.understandMyReadings',
    translationFile: 'hsg',
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ScreeningReadingsPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_SCREENING_UNDERSTAND_READINGS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
    titleTransKey: 'breadcrumbs.understandMyReadings',
    translationFile: 'hsg',
  },
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <VaccinationArticlesPage />,
    displayTitle: () => 'Vaccination',
    pageType: PageType.PRIVATE,
    path: HEALTHIERSG_VACCINATION_ARTICLES_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.healthierSg,
  },
  ...HSG_APPOINTMENTS_ROUTES,
];
